(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bwp-new"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // console.log('Greeting from the BWP 👋');

    function toggleImageVisibility(e) {
      const mobileImage = document.querySelector('.bwp-for-mobile-only');
      const desktopImage = document.querySelector('.bwp-for-desktop-only');

      // Check if the elements are not null or undefined before manipulating them
      if (mobileImage && desktopImage) {
        if (e.matches) {
          mobileImage.classList.remove('hidden');
          desktopImage.classList.add('hidden');
        } else {
          desktopImage.classList.remove('hidden');
          mobileImage.classList.add('hidden');
        }
      }
    }

    const mediaQuery = window.matchMedia('(max-width: 768px)');
    toggleImageVisibility(mediaQuery);
    mediaQuery.addEventListener('change', toggleImageVisibility);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      // this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      // this.header.classList.add('shopify-section-header-sticky', 'animate');
      // this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      // this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ombraz-image-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var imageCarouselSwiper = new Swiper('[ombraz-image-carousel-swiper]', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 8,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.ombraz__image-carousel-navigation-next',
        prevEl: '.ombraz__image-carousel-navigation-prev',
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ombraz-photo-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper('.ombraz-pc__right-content', {
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-quotes"] && !Shopify.designMode) return;
  try {
    
  function pressQuotesSwiper() {
    const pressQuotesContainer = document.querySelector('.press-quotes__swiper');

    if (!pressQuotesContainer) return;

    const config = {
      slidesPerView: 1,
      spaceBetween: 10,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      navigation: {
        nextEl: '.press-quotes__button-next',
        prevEl: '.press-quotes__button-prev',
      },
      breakpoints: {
        560: {
          slidesPerView: 2,
          spaceBetween: 50,
        },
        1199: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
        1599: {
          slidesPerView: 3,
          spaceBetween: 100,
        },
      },
    };

    const pressQuotesSwiper = new Swiper(pressQuotesContainer, config);
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper !== 'undefined') {
      pressQuotesSwiper();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-slider"] && !Shopify.designMode) return;
  try {
    
  function reviewsSlider() {
    const reviewsSliderContainer = document.querySelector('.reviews-slider__swiper');

    if (!reviewsSliderContainer) return;

    const config = {
      slidesPerView: 1.5,
      spaceBetween: 10,
      keyboard: { enabled: true, onlyInViewport: true },
      navigation: {
        nextEl: '.reviews-slider__button-next',
        prevEl: '.reviews-slider__button-prev',
      },
      pagination: {
        el: '.reviews-slider__pagination',
        clickable: true,
      },
      breakpoints: {
        560: { slidesPerView: 2.5, spaceBetween: 50 },
        960: { slidesPerView: 3.5, spaceBetween: 50 },
        1399: { slidesPerView: 4.5, spaceBetween: 50 },
      },
      on: {
        init: function (swiper) {
          if (!swiper.isBeginning) return;
          swiper.el.classList.add('reviews-slider__active--backdrop');
        },
        reachEnd: function (swiper) {
          swiper.el.classList.remove('reviews-slider__active--backdrop');
        },
        fromEdge: function (swiper) {
          swiper.el.classList.add('reviews-slider__active--backdrop');
        },
      },
    };

    const swiper = new Swiper(reviewsSliderContainer, config);
  }

  document.addEventListener('DOMContentLoaded', reviewsSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-attach-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Select all video blocks
    const videoBlocks = document.querySelectorAll('.attach-list__video');

    videoBlocks.forEach(function (videoBlock) {
      const video = videoBlock.querySelector('video');
      const playButton = videoBlock.querySelector('.attach-list__play-button');

      if (!video || !playButton) {
        return;
      }

      // Add click event listener to the play button
      playButton.addEventListener('click', function () {
        // Add controls to the video
        video.setAttribute('controls', 'controls');
        // Play the video
        video.play();
        // Hide the play button
        playButton.classList.add('hide-this');
      });

      // Add event listener for when the video ends
      video.addEventListener('ended', function () {
        // Remove controls from the video
        video.removeAttribute('controls');
        // Show the play button
        playButton.classList.remove('hide-this');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
